import React from "react";

const OrderStatusLoader = () => {
  return (
    <div className="order-status-loader">
      <div className="loading-container">
        <div className="left-wrap">
          <div className="loading-block header-block load-animate"></div>
        </div>
        <div className="right-wrap">
          <div className="loading-block load-animate"></div>
          <div className="loading-block small load-animate"></div>
        </div>
      </div>
      <div className="loading-container">
        <div className="left-wrap">
          <div className="loading-block header-block load-animate"></div>
        </div>
        <div className="right-wrap">
          <div className="loading-block load-animate"></div>
          <div className="loading-block small load-animate"></div>
        </div>
      </div>
      <div className="loading-container noborder">
        <div className="left-wrap">
          <div className="loading-block header-block load-animate"></div>
        </div>
        <div className="right-wrap">
          <div className="loading-block load-animate"></div>
          <div className="loading-block small load-animate"></div>
        </div>
      </div>
    </div>
  );
};

export default OrderStatusLoader;
